<template>
<card id="applicatie" ref="applicationref">
    <template slot="header">
        <div style="float: right">
            <base-button v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN" type="warning" size="lg" class="btn-fill" v-on:click="exportList">
                Export list
            </base-button>
        </div>
        <h2 class="card-title">Proposals report</h2>
    </template>
    <div class="row">
        <div class="col-12">
            <card card-body-classes="table-full-width">
                <div>
                    <tabs ref="tab-calls" type="info" @activate-tab="activateTab" square>
                        <tab-pane :id="call.name" :data-id="call.id" :label="call.title" v-for="call in calls" v-bind:key="call.id">
                            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                                <div>
                                    <el-select class="filter-select mr-2" v-if="loggedUser.role === UserRoles.ADMIN" v-model="filters.regions" multiple collapse-tags placeholder="Filter by regions" clearable @change="handleFilters">
                                        <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value" />
                                    </el-select>
                                    <el-select class="filter-select mr-2" v-if="isCN" v-model="filters.evaluationStatus" placeholder="Filter by evaluation status" clearable @change="handleFilters">
                                        <el-option v-for="item in filterOptions.evaluation_statuses" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value" />
                                    </el-select>
                                    <el-select class="filter-select mr-2" v-else v-model="filters.fpEvaluationStatus" placeholder="Filter by evaluation status" clearable @change="handleFilters">
                                        <el-option v-for="item in filterOptions.fp_evaluation_statuses" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value" />
                                    </el-select>
                                </div>
                                <div class="subsection-switch-container">
                                    <p class="category" style="font-size: 16px; margin-bottom: 10px;">Concept Note / Full Proposal</p>
                                    <base-switch v-model="isCN" type="info" on-text="CN" off-text="FP" style="transform: scale(1.4) translate(10px, 3px)"></base-switch>
                                </div>
                                <!-- <base-input>
                        <el-input
                          type="text"
                          class="mb-3 search-input"
                          prefix-icon="el-icon-search"
                          placeholder="Search and hit enter"
                          v-model="searchQuery"
                          @keyup.native.enter="getItems(1)"
                        >
                        </el-input>
                      </base-input> -->
                            </div>
                            <el-table :data="queriedData" @sort-change="handleSort">
                                <el-table-column sortable label="Reference" min-width="50" property="reference"></el-table-column>
                                <el-table-column sortable label="Organization" property="organization" prop="organization"></el-table-column>

                                <template v-if="isCN">
                                    <el-table-column sortable label="CN Expert 1 - Score" property="cn_score_expert_1" prop="cn_score_expert_1"></el-table-column>
                                    <el-table-column sortable label="CN Expert 1 - Status of Evaluation" max-width="50" property="cn_eval_status_expert_1">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.cn_eval_status_expert_1 === 'SUBMITTED'" class="badge badge-success">{{props.row.cn_eval_status_expert_1}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.cn_eval_status_expert_1}}</span>
                                        </div>
                                    </el-table-column>
                                    <el-table-column sortable label="CN Expert 2 - Score" property="cn_score_expert_2" prop="cn_score_expert_2"></el-table-column>
                                    <el-table-column sortable label="CN Expert 2 - Status of Evaluation" max-width="50" property="cn_eval_status_expert_2">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.cn_eval_status_expert_2 === 'SUBMITTED'" class="badge badge-success">{{props.row.cn_eval_status_expert_2}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.cn_eval_status_expert_2}}</span>
                                        </div>
                                    </el-table-column>
                                    <el-table-column sortable label="CN Average Grade" max-width="50" property="cn_average_score"></el-table-column>
                                    <el-table-column sortable label="CN Evaluation" max-width="50" property="cn_evaluation">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.cn_evaluation === 'Preselected'" class="badge badge-success">{{props.row.cn_evaluation}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.cn_evaluation}}</span>
                                        </div>
                                    </el-table-column>
                                </template>

                                <template v-else>
                                    <el-table-column sortable label="FP Expert 1 - Score" property="fp_score_expert_1" prop="fp_score_expert_1"></el-table-column>
                                    <el-table-column sortable label="FP Expert 1 - Status of Evaluation" max-width="50" property="fp_eval_status_expert_1">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.fp_eval_status_expert_1 === 'SUBMITTED'" class="badge badge-success">{{props.row.fp_eval_status_expert_1}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.fp_eval_status_expert_1}}</span>
                                        </div>
                                    </el-table-column>
                                    <el-table-column sortable label="FP Expert 2 - Score" property="fp_score_expert_2" prop="fp_score_expert_2"></el-table-column>
                                    <el-table-column sortable label="FP Expert 2 - Status of Evaluation" max-width="50" property="fp_eval_status_expert_2">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.fp_eval_status_expert_2 === 'SUBMITTED'" class="badge badge-success">{{props.row.fp_eval_status_expert_2}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.fp_eval_status_expert_2}}</span>
                                        </div>
                                    </el-table-column>
                                    <el-table-column sortable label="FP Average Grade" max-width="50" property="fp_average_score"></el-table-column>
                                    <el-table-column sortable label="FP Evaluation" max-width="50" property="fp_evaluation">
                                        <div slot-scope="props" class="align-center">
                                            <span v-if="props.row.fp_evaluation === 'Passed'" class="badge badge-success">{{props.row.fp_evaluation}}</span>
                                            <span v-else class="badge badge-danger">{{props.row.fp_evaluation}}</span>
                                        </div>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </tab-pane>
                    </tabs>
                </div>
                <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                    <div class="">
                        <p class="card-category">
                            Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
                        </p>
                    </div>
                    <base-pagination v-if="applications.length" @input="getItems" class="pagination-no-border" v-model="pagination.current_page" :per-page="pagination.per_page" :total="pagination.total">
                    </base-pagination>
                </div>
            </card>
        </div>
    </div>

</card>
</template>
<script>
import {
    Table,
    TableColumn,
    Select,
    Option
} from 'element-ui';
import {
    BasePagination,
    BaseSwitch,
    TabPane,
    Tabs,
    Modal
} from 'src/components';
import {
    ApplicationService,
    EvaluationService,
    ReportsService,
    CallService,
    UserRoles
} from '@/services';

export default {
    components: {
        TabPane,
        Tabs,
        BasePagination,
        BaseSwitch,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal
    },
    data() {
        return {
            initialized: false,
            pagination: {},
            sortColumn: undefined,
            sortOrder: undefined,
            perPage: 16,
            searchQuery: undefined,
            propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name', 'countries.name', 'status'],
            isCN: true,
            UserRoles,
            loggedUser: {},
            applications: [],
            proposals: [],
            calls: [],
            currentCallId: 1,
            filterOptions: [],
            filters: {
                status: undefined,
                countries: [],
                regions: [],
                language: undefined
            },
            evaluationTypes: [],
            fpEvaluationStatuses: [
                'Rejected',
                'Passed',
            ],
            modalEvaluate: {
                visibility: false,
                application: {}
            }
        };
    },
    computed: {
        languages: function() {
            let availableLanguages = this.$store.getters['Localization/languages'];
            let languages = [];
            for (let key in availableLanguages) {
                languages[availableLanguages[key].language] = availableLanguages[key];
            }
            return languages;
        },
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.proposals;

            if (!this.isCN) {
                result = result.filter((item) => item.cn_evaluation === 'Preselected');
            }

            return result;
        },
    },
    methods: {
        async getItems(page) {
            let vm = this;
            let page_to_get = page || vm.pagination.current_page;

            let loader = vm.$loading.show();

            await ReportsService.getProposals({
                page: page_to_get,
                call_id: vm.currentCallId,
                per_page: vm.perPage,
                search: vm.searchQuery,
                sort_column: vm.sortColumn,
                sort_direction: vm.sortDirection,
                filter_status: vm.filters.status,
                filter_regions: vm.filters.regions,
                filter_objectives: vm.filters.objectives,
                filter_evaluation_statuses: vm.filters.evaluationStatus,
                filter_fp_evaluation_statuses: vm.filters.fpEvaluationStatus,
                filter_amount: vm.filters.amount,
            }).then((response) => {
                vm.proposals = response.data;
                //vm.pagination = response.data.meta;
                //vm.applications = response.data.data;
            });

            await vm.getFilters();

            loader.hide();
        },
        async getFilters() {
            let vm = this;
            return await ReportsService.getProposalsFilters({
                call_id: vm.currentCallId,
                search: vm.searchQuery,
                filter_status: vm.filters.status,
                filter_regions: vm.filters.regions,
                filter_objectives: vm.filters.objectives,
                filter_evaluation_statuses: vm.filters.evaluationStatus,
                filter_fp_evaluation_statuses: vm.filters.fpEvaluationStatus,
                filter_amount: vm.filters.amount,
            }).then((response) => {
                vm.filterOptions = response.data;
            })
        },
        async getEvaluationTypes() {
            let vm = this;
            let response = await EvaluationService.getEvaluationTypes();
            vm.evaluationTypes = response.data;
        },
        async getCalls() {
            return await CallService.all().then((response) => {
                this.calls = response.data;
                this.currentCallId = this.calls[0].id || 1;
            });
        },
        async activateTab(ev) {
            const vm = this;
            const loader = vm.$loading.show();

            vm.currentCallId = ev.$attrs['data-id'];

            vm.getItems();
            vm.getEvaluationTypes();

            loader.hide();
        },
        handleFilters() {
            let vm = this;
            vm.getItems(1);
        },
        handleSort(data) {
            let vm = this;
            let direction = null;
            if (data.order === 'ascending') {
                direction = 'asc';
            } else if (data.order === 'descending') {
                direction = 'desc';
            }
            vm.sortColumn = data.prop;
            vm.sortDirection = direction;
            vm.getItems(1);
        },
        viewUserProfile(userId) {
            this.$router.push('/users-management/view-profile/' + userId);
        },
        viewApplication(application, openInNewTab) {
            if (openInNewTab) {
                window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
            } else {
                this.$router.push('/application/fill/' + application.grant_id + '/' + application.application_id);
            }
        },
        exportList() {
            let vm = this;
            let loader = vm.$loading.show();

            ReportsService.exportList(vm.filters).then(function(response) {
                if (response.data && response.data.success) {
                    window.open(response.data.url, '_blank');
                }
            });

            loader.hide();
        },
        evaluateApplicationModal(application) {
            let vm = this;
            vm.modalEvaluate.visibility = true;
            vm.modalEvaluate.application = application;
        },
        evaluateApplication(application, evaluationType, evaluationUserId) {
            if (evaluationUserId) {
                window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id + '/' + evaluationUserId, '_blank');
            } else {
                window.open('/application/evaluate/' + evaluationType.nickname + '/' + application.application_id, '_blank');
            }
        },
        requestClarifications(application) {
            this.$router.push('/clarifications/fill/' + application.application_id);
        }
    },
    mounted() {
        let vm = this;

        vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

        vm.getCalls();
        vm.getItems();
        vm.getEvaluationTypes();
    }
};
</script>
<style lang="scss" scoped>
.card-body {
    button {
        margin-left: 1rem;
    }
}

button {
    white-space: nowrap;
}

.evaluations-list {
    list-style-type: disc !important;
}
</style>
